import * as lib from './lib';

export const actions = {
  SET_FEATURE: 'SETTINGS_FEATURES_SET_FEATURE',
  TOGGLE_FEATURE: 'SETTINGS_FEATURES_TOGGLE_FEATURE',
  UPDATE_FEATURES: 'SETTINGS_FEATURES_UPDATE_FEATURES',
  CLEAR: 'SETTINGS_FEATURES_CLEAR',
};

export function setFeature(key, value) {
  return {
    type: actions.SET_FEATURE,
    value: {
      key,
      value,
    },
  };
}

export function toggleFeature(key) {
  return (dispatch, getState) => {
    // ensure we pass the predicate before continuing
    if (lib.checkPredicate(getState(), key) === false) {
      return null;
    }
    return dispatch({
      type: actions.TOGGLE_FEATURE,
      value: key,
    });
  };
}

export function updateFeatures(newState) {
  return {
    type: actions.UPDATE_FEATURES,
    value: newState,
  };
}

export function updateFeaturePredicates() {
  return (dispatch, getState) => {
    const newState = lib.updateFeaturesBasedOnPredicate(getState());
    return dispatch(updateFeatures(newState));
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}



// WEBPACK FOOTER //
// ./src/store/settings/features/actions.js